import {Component} from '@angular/core';
import {ProductStatus} from '@services/model/product';
import {VoilaUserService} from '@services/voila-user.service';
import {User} from '@services/model/user';
import {ProductListComponent} from '@app/product-list/product-list.component';

@Component({
  selector: 'app-hp-products',
  templateUrl: './hp-products.component.html',
  styleUrls: ['./hp-products.component.scss'],
  standalone: true,
  imports: [ProductListComponent],
})
export class HpProductsComponent {
  ProductStatus = ProductStatus;

  constructor(private readonly userService: VoilaUserService) {}

  get hasVotingPermissions(): boolean {
    return User.hasVotingPermission(this.userService.currentUser());
  }
}
